<template>
  <div
    v-if="order.verification_status === VERIFICATION_STATUS.VERIFIED"
    class="bg-green-200 rounded-lg py-4 text-lg text-center text-green-400 font-semibold flex items-center justify-center gap-1"
  >
    <CheckCircleIcon class="w-7 h-7 text-green-500" />
    Verified
  </div>

  <button
    v-else
    type="button"
    :disabled="!canComplete"
    @click="emit('verify')"
    class="btn btn-primary py-4 text-lg flex-1"
    :class="{ 'cursor-not-allowed': !canComplete }"
  >
    Verify Order
  </button>
</template>

<script setup>
import { CheckCircleIcon } from '@heroicons-2/vue/24/outline'
import { VERIFICATION_STATUS } from './constants'

const emit = defineEmits(['verify'])

const props = defineProps({
  order: {
    type: Object,
    required: true
  },
  canComplete: {
    type: Boolean,
    required: true
  }
})
</script>
